const clickLists = document.querySelectorAll('.j-list-nav');

const sectionNavDown = document.querySelector('.j-section-nav__down')
  ? document.querySelector('.j-section-nav__down')
  : null;
const wrapperElements = document.querySelectorAll('.j-section-nav__down-wrapper')
  ? document.querySelectorAll('.j-section-nav__down-wrapper')
  : null;

const clearall = () => {
  if (clickLists) {
    sectionNavDown.classList.remove('is-selected--wrapper');
    clickLists.forEach((ele) => ele.parentNode.classList.remove('is-clicked'));
    wrapperElements.forEach((ele) => ele.classList.remove('is-selected--wrapper', 'is-selected--wrapper--grid-m'));
  }
};

const activateStatus = (clickListNav, elementWrapperN, wrapperElementN) => {
  const checkOpenGlobal = document.body.dataset.state;
  if (checkOpenGlobal === 'global-nav-open') {
    document.body.setAttribute('data-state', '');
  }
  if (clickListNav.parentNode.classList.contains('is-clicked')) {
    clearall();
  } else {
    clearall();
    clickListNav.parentNode.classList.add('is-clicked');
    elementWrapperN.classList.add('is-selected--wrapper');
    wrapperElementN.classList.add('is-selected--wrapper');
    if (wrapperElementN.querySelector('.j-section-nav__list--row')) {
      wrapperElementN.classList.add('is-selected--wrapper--grid-m');
    }
  }
};

const onclickSectionLocal = () => {
  const onElementClick = (e, mapElement) => {
    const targetId = e.currentTarget.getAttribute('data-sub');
    const targetElements = mapElement.get(targetId);
    if (targetElements.clickItem) {
      activateStatus(targetElements.clickItem, targetElements.sectionNavDown, targetElements.wrapperElement);
    }
  };

  const mapElement = new Map();

  if (clickLists) {
    clickLists.forEach((clickItem) => {
      const dataSub = clickItem.getAttribute('data-sub');
      if (wrapperElements) {
        wrapperElements.forEach((wrapperElement) => {
          if (dataSub === wrapperElement.getAttribute('data-wrapper')) {
            mapElement.set(dataSub, {
              clickItem,
              sectionNavDown,
              wrapperElement,
            });
          }
        });
      }
      clickItem.addEventListener('click', (e) => onElementClick(e, mapElement));
    });
  }
};

export const init = () => {
  onclickSectionLocal();
};
